import React, { Component } from 'react'
import { flushSync } from 'react-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BarLoader from "react-spinners/BarLoader";

const axios = require('axios')
const moment = require('moment')
const key = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI1NDFkZDRlYS1lMzRmLTQwNTktYjAwZS1kMzcyY2M4YjYyYmQiLCJlbWFpbCI6Im5vdHNuZnRzQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJwaW5fcG9saWN5Ijp7InJlZ2lvbnMiOlt7ImlkIjoiTllDMSIsImRlc2lyZWRSZXBsaWNhdGlvbkNvdW50IjoxfV0sInZlcnNpb24iOjF9LCJtZmFfZW5hYmxlZCI6ZmFsc2UsInN0YXR1cyI6IkFDVElWRSJ9LCJhdXRoZW50aWNhdGlvblR5cGUiOiJzY29wZWRLZXkiLCJzY29wZWRLZXlLZXkiOiJmMDMyNzEwZGVlNTRmMzVjODc3YyIsInNjb3BlZEtleVNlY3JldCI6IjkyNWViNjg0OTVmNTUxODE4NTgwOTliZDQ2NjFhZDZmYWQ1MzZkZWZiM2M5YTQ1ODBhYWEwZTRkYTU5OWZhY2QiLCJpYXQiOjE2NTY3NzQyNDJ9.op5ptNOy9iNgMF22suZCmazbUOUq65mapG16d0Orclc';

export default class Family extends Component {


    state = {
        name: '',
        dob: '',
        blood_type: 'A+',
        organ_donner: 'Yes',
        allergies: '',
        medications: '',
        medical_history: '',
        health_insurance_info: '',
        kins_name: '',
        kins_ph: '',
        kins_add: '',
        pc_name: '',
        pc_ph: '',
        pc_add: '',
        showConfirm: false,
        pin: '',
        confirmPin: '',
        showThankyou: false,
        walletName: '',
        wallet_address: '',
        startFromOwer: true,
        nft_id: '',
        loading: false,
    }

    async componentDidMount() {
        // await this.getWalletDetailsStargaze();

        window.addEventListener("keplr_keystorechange", (async () => {
            await this.getWalletDetailsStargaze();
        }));
    }

    async didSelectMake() {
        if (this.validate()) {
            this.setState({
                showConfirm: true
            })
        }
    }

    async didSelectConfirm() {

        await this.makeCard();

    }

    setLoading(status) {
        this.setState({
            loading: status
        })
    }

    async makeCard() {
        const {
            name, dob, blood_type, organ_donner, allergies, medications,
            medical_history,
            health_insurance_info,
            kins_name,
            kins_ph,
            kins_add,
            pc_name,
            pc_ph,
            pc_add,
            pin, nft_id,wallet_address
        } = this.state;

        this.setLoading(true)

        let familyCard = {
            name, dob, blood_type, organ_donner, allergies, medications,
            medical_history, health_insurance_info, kins_name, kins_ph,
            kins_add, pc_name, pc_ph, pc_add
        }

        toast.info('Please wait...we are creating your Family+ Card');

        var FormData = require('form-data');
        var data = new FormData();

        data.append('nft_id', nft_id);
        data.append('nft_ref', pin);

        data.append('name', name);
        data.append('dob', dob);
        data.append('blood_type', blood_type);
        data.append('organ_donner', organ_donner);
        data.append('allergies', allergies || '--');
        data.append('medications', medications || '--');
        data.append('medical_history', medical_history || '--');
        data.append('health_insurance_info', health_insurance_info || '--');
        data.append('kins_name', kins_name || '--');
        data.append('kins_ph', kins_ph || '--');
        data.append('kins_add', kins_add || '--');
        data.append('pc_name', pc_name || '--');
        data.append('pc_ph', pc_ph || '--');
        data.append('pc_add', pc_add || '--');
        data.append('wallet', wallet_address);
        

        // data.append('data', JSON.stringify(familyCard));

        // console.log(JSON.stringify(familyCard));

        var config = {
            method: 'post',
            url: 'https://wild-dev-server.xyz/nots/family.php',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        const res = await axios(config);

        console.log(res);

        this.setLoading(false)

        if (res.data.status == 'Ok') {
            toast.success('Your Family+ NFT is completed');
            this.setState({
                name: '',
                dob: '',
                blood_type: 'A+',
                organ_donner: 'Yes',
                allergies: '',
                medications: '',
                medical_history: '',
                health_insurance_info: '',
                kins_name: '',
                kins_ph: '',
                kins_add: '',
                pc_name: '',
                pc_ph: '',
                pc_add: '',
                showConfirm: false,
                pin: '',
                confirmPin: '',
                showThankyou: true,
                startFromOwer: true,
            })
        } else {
            toast.error('Something wrong...Please contact Nots team.')
        }
    }

    renderLoading() {

        const { loading } = this.state
        return (
            <>
                {
                    loading &&
                    <div className='loading'>
                        <div className='loading-inner'>
                            <p>Loading....</p>
                            <BarLoader loading={true}  color="red" />
                        </div>
                    </div>
                }
            </>
        );
    }

    validate() {
        const {
            name, dob, blood_type, organ_donner, allergies, medications,
            medical_history,
            health_insurance_info,
            kins_name,
            kins_ph,
            kins_add,
            pc_name,
            pc_ph,
            pc_add,
            pin, confirmPin
        } = this.state;


        if (!name) {
            toast.warning("Your name is empty.");
            return false
        }

        if (!dob) {
            toast.error("Your date of birth is empty.");
            return false
        }

        var years = moment().diff(dob, 'years', false);
        if (years < 12) {
            toast.error("You shoud be older than 12 years to create a Famli+ NFT");
            return false
        }


        if (!kins_name) {
            toast.error("Your kin's name is empty.");
            return false
        }

        if (!kins_ph) {
            toast.error("Your kin's phone number is empty.");
            return false
        }

        if (kins_ph.length < 10) {
            toast.error("Your kin's phone number is invalid.");
            return false
        }

        if (!pc_name) {
            toast.error("Your primary care provider's name is empty.");
            return false
        }

        if (!pc_ph) {
            toast.error("Your primary care provider's phone number is empty.");
            return false
        }

        if (pc_ph.length < 10) {
            toast.error("Your primary care provider's phone number is invalid.");
            return false
        }

        if (!pin) {
            toast.error("Your pin is empty.");
            return false
        }

        // this.setState({
        //     name: name.replace(/[^a-zA-Z ]/g, ""),
        //     dob,
        //     blood_type,
        //     organ_donner,
        //     allergies: allergies.replace(/[^a-zA-Z ]/g, ""),
        //     medications: medications.replace(/[^a-zA-Z ]/g, ""),
        //     medical_history: medical_history.replace(/[^a-zA-Z ]/g, ""),
        //     health_insurance_info,
        //     kins_name: kins_name.replace(/[^a-zA-Z ]/g, ""),
        //     kins_ph,
        //     kins_add,
        //     pc_name: pc_name.replace(/[^a-zA-Z ]/g, ""),
        //     pc_ph,
        //     pc_add: pc_add.replace(/[^a-zA-Z ]/g, "")
        // })

        if (pin.length < 8) {
            toast.error("Please use a pin code with more than 8 characters");
            return false
        }

        if (pin != confirmPin) {
            toast.error("PIN address mismatched");
            return false
        }


        else return true;

    }

    async getWalletDetailsStargaze() {
        if (window.keplr) {
            try {

                let r = await window.keplr.enable('stargaze-1');

                const { name, bech32Address } = await window.keplr.getKey('stargaze-1')



                toast.success(`Please wait..`);

                this.setLoading(true);

                if (bech32Address) {
                    let url = `https://nots-core.herokuapp.com/nft/Family?account=${bech32Address}`;

                    const { data } = await axios.get(url);

                    if (data.data.length == 0) {
                        this.setLoading(false);
                        toast.info(`You don't have any Family+ NFTS`);
                    } else {
                        var FormData = require('form-data');
                        let availableNFTS = []

                        for (let e of data.data) {
                            var formDate = new FormData();
                            let id = e.name.replace('Family #', 'family#')
                            formDate.append('nft_id', id);



                            var config = {
                                method: 'post',
                                url: 'https://wild-dev-server.xyz/nots/validate.php',
                                headers: {
                                    // 'Content-Type': 'application/json'
                                },
                                data: formDate
                            };

                            const res = await axios(config);

                            console.log('response', id, res);

                            if (res.data == 0) {
                                availableNFTS.push(id);
                            }
                        }

                        console.log('availableNFTS.length', availableNFTS.length);
                        console.log('availableNFTS.length', availableNFTS);

                        // availableNFTS.reverse();

                        this.setLoading(false);

                        if (availableNFTS.length == 0) {
                            toast.info(`You don't have any Family+ NFTS`);
                        } else {
                            toast.success(`You are eligible for making a Family+ NFT`);
                            this.setState({
                                walletName: name,
                                wallet_address: bech32Address,
                                startFromOwer: false,
                                nft_id: availableNFTS[0]
                            });
                        }
                    }
                }else{
                    this.setLoading(false);
                    toast.error('Cannot connect to the Stargaze')
                }


            } catch (error) {
                this.setLoading(false);
                toast.error('Something went wrong...Pleas try again later.')
                console.log(error);
            }
        }
    }

    render() {

        const {
            name, dob, blood_type, organ_donner, allergies, medications,
            medical_history,
            health_insurance_info,
            kins_name,
            kins_ph,
            kins_add,
            pc_name,
            pc_ph,
            pc_add,
            showConfirm,
            showThankyou,
            wallet_address,
            walletName,
            startFromOwer,
            nft_id,
            loading
        } = this.state;


        return (
            <div className='main-container'>


                {
                    startFromOwer ?
                        <div className=''>
                            <section className="home-3 section cta-2" style={{
                                marginTop: -50
                            }}>
                                <div className="container">
                                    <div className="cta-box">
                                        <div className="row align-items-center">
                                            <div className="col-lg-6">
                                                <div className="cta-content">
                                                    {
                                                        showThankyou ?
                                                            <>
                                                                <h1 className="text-white">You have successfully created your
                                                                    <span><b> Family+</b></span> NFT </h1>
                                                                <br />
                                                                <p className=''>Welcome to Nots Family+ ❤️</p>
                                                                <button className='btn btn-primary' onClick={() => {
                                                                    this.setState({
                                                                        showThankyou: false
                                                                    })
                                                                }}>
                                                                    Create again
                                                                </button>
                                                            </>
                                                            :
                                                            <>
                                                                <h1 className="text-white">Create your
                                                                    <span><b> Family+</b></span> Now </h1>
                                                                <br />
                                                                <button className='btn btn-primary'
                                                                    onClick={async () => {
                                                                        await this.getWalletDetailsStargaze()
                                                                    }}>{
                                                                        (wallet_address === '') ? 'Connect Your Wallet and Start' : 'Create'
                                                                    }</button>
                                                                <br />
                                                                <br />
                                                                <p className='text-white'><b>{walletName}</b> : {
                                                                    `${wallet_address.substring(0, 5)}.....${wallet_address.substring(wallet_address.length - 4, wallet_address.length)}`
                                                                }</p>

                                                                <p className=''>Please connect your wallet pick the <b>Family+</b> NFT</p>
                                                                <hr />
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="cta-image">
                                                    <img src="images/not.png" alt="" className="img-fluid" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            {
                                this.renderLoading()
                            }

                        </div>
                        :
                        <>
                            {
                                !showConfirm ?
                                    <>
                                        <h3>Make Your Family+</h3>
                                        <div className='form-container'>

                                            <p className='header-title'>Personal Info</p>

                                            <h4>Name</h4>
                                            <input type='text' className="form-control"
                                                onChange={e => {
                                                    this.setState({ name: e.target.value })
                                                }}
                                                value={name} />

                                            <h4>DOB</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ dob: e.target.value })
                                                }}
                                                type='date' className="form-control"
                                                value={dob} />

                                            <h4>Blood Type</h4>
                                            <select
                                                onChange={e => {
                                                    this.setState({ blood_type: e.target.value })
                                                }}
                                                value={blood_type}
                                                className='form-control'>
                                                <option value='A+'>A+</option>
                                                <option value='A-'>A-</option>
                                                <option value='B+'>B+</option>
                                                <option value='B-'>B-</option>
                                                <option value='O+'>O+</option>
                                                <option value='O-'>O-</option>
                                                <option value='AB+'>AB+</option>
                                                <option value='AB-'>AB-</option>
                                            </select>

                                            <h4>Organ Donor</h4>
                                            <select
                                                onChange={e => {
                                                    this.setState({ organ_donner: e.target.value })
                                                }}
                                                value={organ_donner}
                                                className='form-control'>
                                                <option value='Yes'>Yes</option>
                                                <option value='No'>No</option>
                                            </select>

                                            <h4>Allergies</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ allergies: e.target.value })
                                                }}
                                                type='text' className="form-control">{allergies}</textarea>

                                            <h4>Medications</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ medications: e.target.value })
                                                }}
                                                type='text' className="form-control" >{medications}</textarea>

                                            <h4>Medical History</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ medical_history: e.target.value })
                                                }}
                                                type='text' className="form-control" >{medical_history}</textarea>

                                            <h4>Health Insurance Info</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ health_insurance_info: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={health_insurance_info} />

                                            <p className='header-title'>Next of Kin's Info</p>

                                            <h4>Name</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ kins_name: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={kins_name} />

                                            <h4>Phone Number</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ kins_ph: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={kins_ph} />

                                            <h4>Address</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ kins_add: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={kins_add} />

                                            <p className='header-title'>Primary Care Provider</p>

                                            <h4>Name</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ pc_name: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={pc_name} />

                                            <h4>Phone Number</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ pc_ph: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={pc_ph} />

                                            <h4>Address</h4>
                                            <textarea
                                                onChange={e => {
                                                    this.setState({ pc_add: e.target.value })
                                                }}
                                                type='text' className="form-control"
                                                value={pc_add} />

                                            <p className='header-title'>Security</p>

                                            <h4>Pin</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ pin: e.target.value })
                                                }}
                                                type='text' className="form-control" />

                                            <p className='family-info-pin'>
                                                You cannot change this pin later.
                                            </p>
                                            <h4>Confirm Pin</h4>
                                            <input
                                                onChange={e => {
                                                    this.setState({ confirmPin: e.target.value })
                                                }}
                                                type='text' className="form-control" />


                                        </div>

                                        <button
                                            onClick={() => { this.didSelectMake() }}
                                            className='apply'>Make my Family+ ({nft_id})</button>

                                        {
                                            this.renderLoading()
                                        }


                                    </>
                                    :
                                    <>
                                        <h3>Confirm Your Family+ Details</h3>
                                        <div className='form-container report'>
                                            <p className='header-title'>Personal Info</p>
                                            <h4><b>Name : </b>{name}</h4>
                                            <h4><b>DOB : </b>{dob}</h4>
                                            <h4><b>Blood Type : </b>{blood_type}</h4>
                                            <h4><b>Organ Donor : </b>{organ_donner}</h4>
                                            <h4><b>Allergies : </b>{allergies ? allergies : 'N/A'}</h4>
                                            <h4><b>Medications :</b>{medications ? medications : 'N/A'}</h4>
                                            <h4><b>Medical History : </b>{medical_history ? medical_history : 'N/A'}</h4>
                                            <h4><b>Health Insurance Info : </b>{health_insurance_info ? health_insurance_info : 'N/A'}</h4>

                                            <p className='header-title'>Next of Kin's Info</p>
                                            <h4><b>Name : </b>{kins_name}</h4>
                                            <h4><b>Phone Number : </b>{kins_ph}</h4>
                                            <h4><b>Address : </b>{kins_add ? kins_add : 'N/A'}</h4>

                                            <p className='header-title'>Primary Care Provider</p>
                                            <h4><b>Name : </b>{pc_name}</h4>
                                            <h4><b>Phone Number : </b>{pc_ph}</h4>
                                            <h4><b>Address : </b>{pc_add ? pc_add : 'N/A'}</h4>
                                            <div className='' style={{ minHeight: 30 }} />
                                        </div>

                                        <p className='family-info'>
                                            By clicking `Confirm` you will agreed to the terms and condtions provided by Nots Family+ NFT program and agreed to save above details under Nots  terms and condtions.
                                        </p>

                                        <div className='btn-container'>
                                            <button
                                                onClick={() => {
                                                    this.setState({
                                                        showConfirm: false
                                                    })
                                                }}
                                                className='edit'>Edit</button>

                                            <button
                                                onClick={() => { this.didSelectConfirm() }}
                                                className='confirm'>Confirm</button>
                                        </div>

                                        {
                                            this.renderLoading()
                                        }


                                    </>
                            }
                        </>
                }


                <ToastContainer />
            </div>
        )
    }
}
